import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {CurrentOddsModuleTerms} from "./current-odds-module.terms";
import {APP} from "../../../../core/app/consts";

export class CurrentOddsModuleConfig extends BaseConfig {
  source: APP.ANALYTICS.SOURCES;

  static injectables = [CurrentOddsModuleTerms];

  constructor(terms: CurrentOddsModuleTerms){
    super('currentOddsModule', null , terms)

    this.source = APP.ANALYTICS.SOURCES.currentOdds
  }
}
